<nz-upload
  class="avatar-uploader mx-auto"
  [nzAction]="uploadAction"
  nzName="file"
  [nzListType]="'picture'"
  [nzDisabled]="uploadLoading || readOnly"
  [nzBeforeUpload]="beforeUpload"
  nzType="drag"
  [nzAccept]="accept"
  (onProgress)="onProgress($event)"
  (nzChange)="handleChangeEvent($event)"
  [nzFileList]="fileList"
  [nzShowUploadList]="isShowUploadList"
>
  <div>

    <ng-content select="[uploadState]" ></ng-content>
    <div>
      <ng-content></ng-content>
      <!-- <div class="ant-upload-text text-secondary font-bold" *ngIf="!uploadLoading">{{ label }}</div> -->
      <span nz-icon *ngIf="uploadLoading" [nzType]="'loading'"></span>
      <div *ngIf="uploadLoading"> {{"::Host:upload:download" | abpLocalization}}{{uploadProgress}} %</div>
    </div>
    <nz-progress
      *ngIf="uploadLoading && hasProgress"
      class="block mx-auto w-4/5"
      [nzStrokeColor]="{ '0%': '#108ee9', '100%': '#87d068' }"
      [nzPercent]="uploadProgress"
    ></nz-progress>
  </div>
</nz-upload>
